import { Space, Typography } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';
import React from 'react';

import { useAppSelector } from 'shared/lib';

import { metadataSelector } from 'entities/metadata';

const { Text, Heading } = Typography;

export const LandingHeader: FC = () => {
  const isMobile = useIsMobile();
  const { heading, description } = useAppSelector(metadataSelector);

  return (
    <Space
      direction="vertical"
      className="h-mt-40 h-text-center"
    >
      <Heading
        level={1}
        className="h-mb-16"
      >
        {heading}
      </Heading>

      <Text
        size={isMobile ? 14 : 16}
        className="h-color-D60"
      >
        {description}
      </Text>
    </Space>
  );
};
